function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsfuel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1266px",
    height: "306px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.743
    },
    fill: "#fe1300",
    d: "M 1135.5,107.5 C 1159.84,107.333 1184.17,107.5 1208.5,108C 1211.42,108.417 1214.09,109.417 1216.5,111C 1185.83,111.667 1155.17,111.667 1124.5,111C 1128.16,109.407 1131.83,108.241 1135.5,107.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.919
    },
    fill: "#fefffe",
    d: "M 86.5,108.5 C 104.5,108.5 122.5,108.5 140.5,108.5C 140.5,109.5 140.5,110.5 140.5,111.5C 122.5,111.5 104.5,111.5 86.5,111.5C 86.5,110.5 86.5,109.5 86.5,108.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.896
    },
    fill: "#fefffe",
    d: "M 162.5,108.5 C 177.5,108.5 192.5,108.5 207.5,108.5C 207.5,109.5 207.5,110.5 207.5,111.5C 192.152,111.833 176.819,111.499 161.5,110.5C 161.863,109.817 162.196,109.15 162.5,108.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.87
    },
    fill: "#fefffe",
    d: "M 246.5,108.5 C 278.168,108.333 309.835,108.5 341.5,109C 340.833,109.667 340.167,110.333 339.5,111C 306.5,111.667 273.5,111.667 240.5,111C 242.611,110.155 244.611,109.322 246.5,108.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.924
    },
    fill: "#fefffe",
    d: "M 355.5,108.5 C 392.167,108.5 428.833,108.5 465.5,108.5C 465.5,109.5 465.5,110.5 465.5,111.5C 429.165,111.667 392.832,111.5 356.5,111C 355.748,110.329 355.414,109.496 355.5,108.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.919
    },
    fill: "#fefffe",
    d: "M 475.5,108.5 C 493.5,108.5 511.5,108.5 529.5,108.5C 529.5,109.5 529.5,110.5 529.5,111.5C 511.5,111.5 493.5,111.5 475.5,111.5C 475.5,110.5 475.5,109.5 475.5,108.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.896
    },
    fill: "#fefffe",
    d: "M 551.5,108.5 C 566.5,108.5 581.5,108.5 596.5,108.5C 596.5,109.5 596.5,110.5 596.5,111.5C 581.152,111.833 565.819,111.499 550.5,110.5C 550.863,109.817 551.196,109.15 551.5,108.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.931
    },
    fill: "#fefffe",
    d: "M 612.5,108.5 C 648.833,108.5 685.167,108.5 721.5,108.5C 721.5,109.5 721.5,110.5 721.5,111.5C 685.498,111.667 649.498,111.5 613.5,111C 612.748,110.329 612.414,109.496 612.5,108.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.922
    },
    fill: "#fefffe",
    d: "M 736.5,108.5 C 754.5,108.5 772.5,108.5 790.5,108.5C 790.5,109.5 790.5,110.5 790.5,111.5C 772.83,111.667 755.164,111.5 737.5,111C 736.748,110.329 736.414,109.496 736.5,108.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.916
    },
    fill: "#fe1300",
    d: "M 843.5,108.5 C 878.835,108.333 914.168,108.5 949.5,109C 951.044,109.29 952.377,109.956 953.5,111C 917.167,111.667 880.833,111.667 844.5,111C 843.748,110.329 843.414,109.496 843.5,108.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.899
    },
    fill: "#fe1300",
    d: "M 975.5,108.5 C 1010.83,108.333 1046.17,108.5 1081.5,109C 1082.83,109.667 1084.17,110.333 1085.5,111C 1049.17,111.667 1012.83,111.667 976.5,111C 975.748,110.329 975.414,109.496 975.5,108.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.804
    },
    fill: "#fefffe",
    d: "M 88.5,112.5 C 105.5,112.5 122.5,112.5 139.5,112.5C 139.67,113.822 139.337,114.989 138.5,116C 122.5,116.667 106.5,116.667 90.5,116C 89.1772,115.184 88.5106,114.017 88.5,112.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.803
    },
    fill: "#fefffe",
    d: "M 160.5,112.5 C 175.848,112.167 191.181,112.501 206.5,113.5C 206.167,114.167 205.833,114.833 205.5,115.5C 190.167,116.833 174.833,116.833 159.5,115.5C 160.127,114.583 160.461,113.583 160.5,112.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.735
    },
    fill: "#fefffe",
    d: "M 237.5,112.5 C 270.502,112.333 303.502,112.5 336.5,113C 332.924,115.19 329.257,117.19 325.5,119C 307.833,119.333 290.167,119.667 272.5,120C 271.833,121 271.167,122 270.5,123C 255.5,123.667 240.5,123.667 225.5,123C 226.743,121.846 227.743,120.512 228.5,119C 261.164,118.21 293.831,117.543 326.5,117C 295.167,116.667 263.833,116.333 232.5,116C 234.233,114.811 235.9,113.644 237.5,112.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.75
    },
    fill: "#fefffe",
    d: "M 357.5,112.5 C 393.167,112.5 428.833,112.5 464.5,112.5C 464.201,115.642 462.534,117.809 459.5,119C 441.833,119.333 424.167,119.667 406.5,120C 405.833,121 405.167,122 404.5,123C 389.489,123.833 374.489,123.666 359.5,122.5C 360.246,121.264 360.579,119.93 360.5,118.5C 393.836,118.235 427.169,117.735 460.5,117C 426.833,116.667 393.167,116.333 359.5,116C 358.177,115.184 357.511,114.017 357.5,112.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.804
    },
    fill: "#fefffe",
    d: "M 477.5,112.5 C 494.5,112.5 511.5,112.5 528.5,112.5C 528.67,113.822 528.337,114.989 527.5,116C 511.5,116.667 495.5,116.667 479.5,116C 478.177,115.184 477.511,114.017 477.5,112.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.803
    },
    fill: "#fefffe",
    d: "M 549.5,112.5 C 564.848,112.167 580.181,112.501 595.5,113.5C 595.167,114.167 594.833,114.833 594.5,115.5C 579.167,116.833 563.833,116.833 548.5,115.5C 549.127,114.583 549.461,113.583 549.5,112.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.75
    },
    fill: "#fefffe",
    d: "M 614.5,112.5 C 650.173,112.167 685.84,112.5 721.5,113.5C 720.603,116.565 718.603,118.398 715.5,119C 698.167,119.333 680.833,119.667 663.5,120C 662.833,121 662.167,122 661.5,123C 646.504,123.5 631.504,123.667 616.5,123.5C 616.421,122.07 616.754,120.736 617.5,119.5C 650.822,118.235 684.155,117.401 717.5,117C 683.833,116.667 650.167,116.333 616.5,116C 615.177,115.184 614.511,114.017 614.5,112.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.795
    },
    fill: "#fefffe",
    d: "M 738.5,112.5 C 755.837,112.333 773.17,112.5 790.5,113C 789.663,114.011 789.33,115.178 789.5,116.5C 773.163,116.667 756.83,116.5 740.5,116C 739.177,115.184 738.511,114.017 738.5,112.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.815
    },
    fill: "#fe1300",
    d: "M 845.5,112.5 C 882.168,112.333 918.835,112.5 955.5,113C 956.167,114 956.833,115 957.5,116C 920.833,116.667 884.167,116.667 847.5,116C 846.177,115.184 845.511,114.017 845.5,112.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.816
    },
    fill: "#fe1300",
    d: "M 977.5,112.5 C 1014.17,112.333 1050.83,112.5 1087.5,113C 1088.17,114 1088.83,115 1089.5,116C 1052.83,116.667 1016.17,116.667 979.5,116C 978.177,115.184 977.511,114.017 977.5,112.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.818
    },
    fill: "#fe1300",
    d: "M 1121.5,112.5 C 1153.84,112.333 1186.17,112.5 1218.5,113C 1219.17,114 1219.83,115 1220.5,116C 1185.83,116.667 1151.17,116.667 1116.5,116C 1118.35,114.97 1120.01,113.804 1121.5,112.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.757
    },
    fill: "#fe1300",
    d: "M 894.5,117.5 C 915.827,118.174 937.16,118.508 958.5,118.5C 958.5,120.167 958.5,121.833 958.5,123.5C 943.485,123.833 928.485,123.499 913.5,122.5C 913.833,121.833 914.167,121.167 914.5,120.5C 907.858,119.336 901.192,119.169 894.5,120C 893.833,121 893.167,122 892.5,123C 877.504,123.5 862.504,123.667 847.5,123.5C 847.421,122.07 847.754,120.736 848.5,119.5C 863.995,118.833 879.328,118.167 894.5,117.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.756
    },
    fill: "#fe1300",
    d: "M 1026.5,117.5 C 1047.83,118.174 1069.16,118.508 1090.5,118.5C 1090.5,120.167 1090.5,121.833 1090.5,123.5C 1075.49,123.833 1060.49,123.499 1045.5,122.5C 1045.83,121.833 1046.17,121.167 1046.5,120.5C 1039.86,119.336 1033.19,119.169 1026.5,120C 1025.83,121 1025.17,122 1024.5,123C 1009.49,123.833 994.489,123.666 979.5,122.5C 980.246,121.264 980.579,119.93 980.5,118.5C 996.009,118.83 1011.34,118.496 1026.5,117.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.762
    },
    fill: "#fe1300",
    d: "M 1156.5,117.5 C 1178.16,118.159 1199.83,118.492 1221.5,118.5C 1221.71,120.144 1221.38,121.644 1220.5,123C 1205.84,123.5 1191.17,123.667 1176.5,123.5C 1176.33,122.178 1176.66,121.011 1177.5,120C 1170.48,119.169 1163.48,119.336 1156.5,120.5C 1156.17,121.167 1155.83,121.833 1155.5,122.5C 1140.5,123.833 1125.5,123.833 1110.5,122.5C 1111.31,121.186 1112.31,120.019 1113.5,119C 1128.01,118.831 1142.34,118.331 1156.5,117.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.792
    },
    fill: "#fefffe",
    d: "M 91.5,118.5 C 106.837,118.333 122.17,118.5 137.5,119C 136.707,120.085 136.04,121.252 135.5,122.5C 120.178,123.666 104.844,123.833 89.5,123C 90.2666,121.53 90.9332,120.03 91.5,118.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.788
    },
    fill: "#fefffe",
    d: "M 157.5,118.5 C 172.833,118.5 188.167,118.5 203.5,118.5C 203.579,119.93 203.246,121.264 202.5,122.5C 187.167,123.833 171.833,123.833 156.5,122.5C 157.246,121.264 157.579,119.93 157.5,118.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.792
    },
    fill: "#fefffe",
    d: "M 480.5,118.5 C 495.837,118.333 511.17,118.5 526.5,119C 525.707,120.085 525.04,121.252 524.5,122.5C 509.178,123.666 493.844,123.833 478.5,123C 479.267,121.53 479.933,120.03 480.5,118.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.788
    },
    fill: "#fefffe",
    d: "M 546.5,118.5 C 561.833,118.5 577.167,118.5 592.5,118.5C 592.579,119.93 592.246,121.264 591.5,122.5C 576.167,123.833 560.833,123.833 545.5,122.5C 546.246,121.264 546.579,119.93 546.5,118.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.792
    },
    fill: "#fefffe",
    d: "M 741.5,118.5 C 756.848,118.167 772.181,118.501 787.5,119.5C 786.96,120.748 786.293,121.915 785.5,123C 770.489,123.833 755.489,123.666 740.5,122.5C 741.246,121.264 741.579,119.93 741.5,118.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.876
    },
    fill: "#fefffe",
    d: "M 87.5,126.5 C 102.848,126.167 118.181,126.501 133.5,127.5C 132.96,128.748 132.293,129.915 131.5,131C 116.504,131.5 101.504,131.667 86.5,131.5C 86.6287,129.784 86.962,128.117 87.5,126.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.877
    },
    fill: "#fefffe",
    d: "M 154.5,126.5 C 169.837,126.333 185.17,126.5 200.5,127C 199.833,128.333 199.167,129.667 198.5,131C 183.167,131.667 167.833,131.667 152.5,131C 153.582,129.67 154.249,128.17 154.5,126.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.872
    },
    fill: "#fefffe",
    d: "M 223.5,126.5 C 238.5,126.5 253.5,126.5 268.5,126.5C 268.579,127.93 268.246,129.264 267.5,130.5C 252.167,131.833 236.833,131.833 221.5,130.5C 222.18,129.14 222.847,127.807 223.5,126.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.875
    },
    fill: "#fefffe",
    d: "M 357.5,126.5 C 372.5,126.5 387.5,126.5 402.5,126.5C 402.579,127.93 402.246,129.264 401.5,130.5C 386.178,131.666 370.844,131.833 355.5,131C 356.267,129.53 356.933,128.03 357.5,126.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.876
    },
    fill: "#fefffe",
    d: "M 476.5,126.5 C 491.848,126.167 507.181,126.501 522.5,127.5C 521.96,128.748 521.293,129.915 520.5,131C 505.504,131.5 490.504,131.667 475.5,131.5C 475.629,129.784 475.962,128.117 476.5,126.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.877
    },
    fill: "#fefffe",
    d: "M 543.5,126.5 C 558.837,126.333 574.17,126.5 589.5,127C 588.833,128.333 588.167,129.667 587.5,131C 572.167,131.667 556.833,131.667 541.5,131C 542.582,129.67 543.249,128.17 543.5,126.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.874
    },
    fill: "#fefffe",
    d: "M 614.5,126.5 C 629.515,126.167 644.515,126.501 659.5,127.5C 658.754,128.736 658.421,130.07 658.5,131.5C 643.152,131.833 627.819,131.499 612.5,130.5C 613.18,129.14 613.847,127.807 614.5,126.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.874
    },
    fill: "#fefffe",
    d: "M 738.5,126.5 C 753.837,126.333 769.17,126.5 784.5,127C 783.707,128.085 783.04,129.252 782.5,130.5C 767.178,131.666 751.844,131.833 736.5,131C 737.267,129.53 737.933,128.03 738.5,126.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.871
    },
    fill: "#fe1300",
    d: "M 845.5,126.5 C 860.5,126.5 875.5,126.5 890.5,126.5C 890.579,127.93 890.246,129.264 889.5,130.5C 874.167,131.833 858.833,131.833 843.5,130.5C 844.18,129.14 844.847,127.807 845.5,126.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.876
    },
    fill: "#fe1300",
    d: "M 911.5,126.5 C 926.837,126.333 942.17,126.5 957.5,127C 956.707,128.085 956.04,129.252 955.5,130.5C 940.178,131.666 924.844,131.833 909.5,131C 910.582,129.67 911.249,128.17 911.5,126.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.876
    },
    fill: "#fe1300",
    d: "M 977.5,126.5 C 992.5,126.5 1007.5,126.5 1022.5,126.5C 1022.58,127.93 1022.25,129.264 1021.5,130.5C 1006.18,131.666 990.844,131.833 975.5,131C 976.267,129.53 976.933,128.03 977.5,126.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.88
    },
    fill: "#fe1300",
    d: "M 1043.5,126.5 C 1058.84,126.333 1074.17,126.5 1089.5,127C 1088.71,128.085 1088.04,129.252 1087.5,130.5C 1072.51,131.499 1057.51,131.833 1042.5,131.5C 1042.63,129.784 1042.96,128.117 1043.5,126.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.875
    },
    fill: "#fe1300",
    d: "M 1107.5,126.5 C 1122.85,126.167 1138.18,126.501 1153.5,127.5C 1152.96,128.748 1152.29,129.915 1151.5,131C 1136.5,131.5 1121.5,131.667 1106.5,131.5C 1106.63,129.784 1106.96,128.117 1107.5,126.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.875
    },
    fill: "#fe1300",
    d: "M 1174.5,126.5 C 1189.5,126.5 1204.5,126.5 1219.5,126.5C 1219.58,127.93 1219.25,129.264 1218.5,130.5C 1203.17,131.833 1187.83,131.833 1172.5,130.5C 1173.18,129.14 1173.85,127.807 1174.5,126.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.772
    },
    fill: "#fefffe",
    d: "M 83.5,135.5 C 98.8478,135.167 114.181,135.501 129.5,136.5C 128.253,138.323 127.586,140.323 127.5,142.5C 112.152,142.833 96.8189,142.499 81.5,141.5C 82.3721,139.55 83.0388,137.55 83.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.776
    },
    fill: "#fefffe",
    d: "M 150.5,135.5 C 165.837,135.333 181.17,135.5 196.5,136C 195.692,138.088 194.692,140.088 193.5,142C 178.504,142.5 163.504,142.667 148.5,142.5C 148.878,140.079 149.545,137.746 150.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8
    },
    fill: "#fefffe",
    d: "M 219.5,135.5 C 234.5,135.5 249.5,135.5 264.5,135.5C 264.528,137.582 263.861,139.416 262.5,141C 277.5,141.333 292.5,141.667 307.5,142C 311.165,143.497 314.498,145.497 317.5,148C 319.219,149.87 320.219,152.037 320.5,154.5C 284.161,154.833 247.827,154.5 211.5,153.5C 212.373,151.587 213.373,149.753 214.5,148C 247.5,147.667 280.5,147.333 313.5,147C 296.233,145.708 278.899,145.041 261.5,145C 261.043,144.586 260.709,144.086 260.5,143.5C 246.182,142.501 231.849,142.167 217.5,142.5C 217.767,140.035 218.434,137.701 219.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.775
    },
    fill: "#fefffe",
    d: "M 353.5,135.5 C 368.5,135.5 383.5,135.5 398.5,135.5C 398.414,137.677 397.747,139.677 396.5,141.5C 381.515,142.499 366.515,142.833 351.5,142.5C 351.767,140.035 352.434,137.701 353.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.772
    },
    fill: "#fefffe",
    d: "M 472.5,135.5 C 487.848,135.167 503.181,135.501 518.5,136.5C 517.253,138.323 516.586,140.323 516.5,142.5C 501.152,142.833 485.819,142.499 470.5,141.5C 471.372,139.55 472.039,137.55 472.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.776
    },
    fill: "#fefffe",
    d: "M 539.5,135.5 C 554.837,135.333 570.17,135.5 585.5,136C 584.692,138.088 583.692,140.088 582.5,142C 567.504,142.5 552.504,142.667 537.5,142.5C 537.878,140.079 538.545,137.746 539.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.772
    },
    fill: "#fefffe",
    d: "M 610.5,135.5 C 625.5,135.5 640.5,135.5 655.5,135.5C 655.414,137.677 654.747,139.677 653.5,141.5C 638.515,142.499 623.515,142.833 608.5,142.5C 608.394,139.921 609.061,137.588 610.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.777
    },
    fill: "#fefffe",
    d: "M 734.5,135.5 C 749.5,135.5 764.5,135.5 779.5,135.5C 779.414,137.677 778.747,139.677 777.5,141.5C 762.515,142.499 747.515,142.833 732.5,142.5C 732.767,140.035 733.434,137.701 734.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.773
    },
    fill: "#fe1300",
    d: "M 841.5,135.5 C 856.5,135.5 871.5,135.5 886.5,135.5C 886.414,137.677 885.747,139.677 884.5,141.5C 869.515,142.499 854.515,142.833 839.5,142.5C 839.394,139.921 840.061,137.588 841.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.778
    },
    fill: "#fe1300",
    d: "M 907.5,135.5 C 922.5,135.5 937.5,135.5 952.5,135.5C 952.414,137.677 951.747,139.677 950.5,141.5C 935.515,142.499 920.515,142.833 905.5,142.5C 905.878,140.079 906.545,137.746 907.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.776
    },
    fill: "#fe1300",
    d: "M 973.5,135.5 C 988.5,135.5 1003.5,135.5 1018.5,135.5C 1018.41,137.677 1017.75,139.677 1016.5,141.5C 1001.51,142.499 986.515,142.833 971.5,142.5C 971.767,140.035 972.434,137.701 973.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.774
    },
    fill: "#fe1300",
    d: "M 1039.5,135.5 C 1054.84,135.333 1070.17,135.5 1085.5,136C 1084.31,137.912 1083.31,139.912 1082.5,142C 1067.5,142.5 1052.5,142.667 1037.5,142.5C 1037.88,140.079 1038.54,137.746 1039.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.771
    },
    fill: "#fe1300",
    d: "M 1103.5,135.5 C 1118.85,135.167 1134.18,135.501 1149.5,136.5C 1148.63,138.413 1147.63,140.247 1146.5,142C 1131.5,142.5 1116.5,142.667 1101.5,142.5C 1101.88,140.079 1102.54,137.746 1103.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.771
    },
    fill: "#fe1300",
    d: "M 1170.5,135.5 C 1185.5,135.5 1200.5,135.5 1215.5,135.5C 1215.41,137.677 1214.75,139.677 1213.5,141.5C 1198.17,142.833 1182.83,142.833 1167.5,141.5C 1168.51,139.473 1169.51,137.473 1170.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.817
    },
    fill: "#fefffe",
    d: "M 78.5,147.5 C 93.837,147.333 109.17,147.5 124.5,148C 123.692,150.088 122.692,152.088 121.5,154C 106.504,154.5 91.5037,154.667 76.5,154.5C 76.8782,152.079 77.5448,149.746 78.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.817
    },
    fill: "#fefffe",
    d: "M 145.5,147.5 C 160.5,147.5 175.5,147.5 190.5,147.5C 190.414,149.677 189.747,151.677 188.5,153.5C 173.167,154.833 157.833,154.833 142.5,153.5C 143.513,151.473 144.513,149.473 145.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.944
    },
    fill: "#fefffe",
    d: "M 348.5,147.5 C 363.515,147.167 378.515,147.501 393.5,148.5C 391.913,150.446 392.246,151.946 394.5,153C 411.177,153.167 427.843,153.667 444.5,154.5C 440.668,157.25 436.668,159.75 432.5,162C 417.455,162.182 402.455,162.682 387.5,163.5C 380.689,177.622 374.022,191.788 367.5,206C 352.837,206.5 338.17,206.667 323.5,206.5C 329.038,190.897 335.372,175.564 342.5,160.5C 357.5,159.833 372.5,159.167 387.5,158.5C 388.04,157.252 388.707,156.085 389.5,155C 374.822,154.833 360.155,154.333 345.5,153.5C 346.513,151.473 347.513,149.473 348.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.817
    },
    fill: "#fefffe",
    d: "M 467.5,147.5 C 482.837,147.333 498.17,147.5 513.5,148C 512.692,150.088 511.692,152.088 510.5,154C 495.504,154.5 480.504,154.667 465.5,154.5C 465.878,152.079 466.545,149.746 467.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.817
    },
    fill: "#fefffe",
    d: "M 534.5,147.5 C 549.5,147.5 564.5,147.5 579.5,147.5C 579.414,149.677 578.747,151.677 577.5,153.5C 562.167,154.833 546.833,154.833 531.5,153.5C 532.513,151.473 533.513,149.473 534.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.931
    },
    fill: "#fefffe",
    d: "M 605.5,147.5 C 620.515,147.167 635.515,147.501 650.5,148.5C 649.754,149.736 649.421,151.07 649.5,152.5C 666.744,152.175 683.91,152.508 701,153.5C 697.887,157.351 693.72,160.184 688.5,162C 674.167,162.333 659.833,162.667 645.5,163C 644.692,163.308 644.025,163.808 643.5,164.5C 638.833,174.833 634.167,185.167 629.5,195.5C 630.025,196.192 630.692,196.692 631.5,197C 648.5,197.333 665.5,197.667 682.5,198C 678.431,201.063 674.098,203.73 669.5,206C 639.835,206.5 610.169,206.667 580.5,206.5C 586.038,190.897 592.372,175.564 599.5,160.5C 614.5,159.833 629.5,159.167 644.5,158.5C 645.04,157.252 645.707,156.085 646.5,155C 631.822,154.833 617.155,154.333 602.5,153.5C 603.513,151.473 604.513,149.473 605.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.815
    },
    fill: "#fefffe",
    d: "M 729.5,147.5 C 744.515,147.167 759.515,147.501 774.5,148.5C 773.833,150.167 773.167,151.833 772.5,153.5C 757.167,154.833 741.833,154.833 726.5,153.5C 727.513,151.473 728.513,149.473 729.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.817
    },
    fill: "#fe1300",
    d: "M 836.5,147.5 C 851.515,147.167 866.515,147.501 881.5,148.5C 880.253,150.323 879.586,152.323 879.5,154.5C 864.152,154.833 848.819,154.499 833.5,153.5C 834.513,151.473 835.513,149.473 836.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.814
    },
    fill: "#fe1300",
    d: "M 902.5,147.5 C 917.5,147.5 932.5,147.5 947.5,147.5C 947.414,149.677 946.747,151.677 945.5,153.5C 930.178,154.666 914.844,154.833 899.5,154C 900.406,151.779 901.406,149.612 902.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.818
    },
    fill: "#fe1300",
    d: "M 968.5,147.5 C 983.515,147.167 998.515,147.501 1013.5,148.5C 1012.25,150.323 1011.59,152.323 1011.5,154.5C 996.152,154.833 980.819,154.499 965.5,153.5C 966.513,151.473 967.513,149.473 968.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.82
    },
    fill: "#fe1300",
    d: "M 1034.5,147.5 C 1049.5,147.5 1064.5,147.5 1079.5,147.5C 1079.41,149.677 1078.75,151.677 1077.5,153.5C 1062.51,154.499 1047.51,154.833 1032.5,154.5C 1032.77,152.035 1033.43,149.701 1034.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.819
    },
    fill: "#fe1300",
    d: "M 1098.5,147.5 C 1113.84,147.333 1129.17,147.5 1144.5,148C 1143.37,149.753 1142.37,151.587 1141.5,153.5C 1126.51,154.499 1111.51,154.833 1096.5,154.5C 1096.77,152.035 1097.43,149.701 1098.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.817
    },
    fill: "#fe1300",
    d: "M 1164.5,147.5 C 1179.85,147.167 1195.18,147.501 1210.5,148.5C 1209.63,150.413 1208.63,152.247 1207.5,154C 1192.49,154.833 1177.49,154.666 1162.5,153.5C 1163.37,151.55 1164.04,149.55 1164.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.95
    },
    fill: "#fefffe",
    d: "M 73.5,159.5 C 88.5,159.5 103.5,159.5 118.5,159.5C 113.5,172.167 108.5,184.833 103.5,197.5C 109.842,197.666 116.175,197.5 122.5,197C 128.552,185.06 134.219,172.893 139.5,160.5C 154.833,159.167 170.167,159.167 185.5,160.5C 181,170.833 176.5,181.167 172,191.5C 165.631,200.104 157.131,205.271 146.5,207C 121.5,207.667 96.5,207.667 71.5,207C 61.7428,205.582 57.9095,200.082 60,190.5C 64.5147,180.141 69.0147,169.807 73.5,159.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.953
    },
    fill: "#fefffe",
    d: "M 210.5,159.5 C 247.168,159.333 283.835,159.5 320.5,160C 315.538,170.759 310.705,181.592 306,192.5C 300.631,199.109 293.797,203.609 285.5,206C 253.828,206.833 222.161,206.667 190.5,205.5C 194.503,202.496 198.837,199.996 203.5,198C 221.167,197.667 238.833,197.333 256.5,197C 257.416,196.626 258.25,196.126 259,195.5C 262.372,187.924 265.872,180.424 269.5,173C 253.318,171.681 236.985,171.015 220.5,171C 214.444,169.449 211.11,165.615 210.5,159.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.95
    },
    fill: "#fefffe",
    d: "M 462.5,159.5 C 477.5,159.5 492.5,159.5 507.5,159.5C 502.5,172.167 497.5,184.833 492.5,197.5C 498.842,197.666 505.175,197.5 511.5,197C 517.552,185.06 523.219,172.893 528.5,160.5C 543.833,159.167 559.167,159.167 574.5,160.5C 570,170.833 565.5,181.167 561,191.5C 554.631,200.104 546.131,205.271 535.5,207C 510.5,207.667 485.5,207.667 460.5,207C 450.743,205.582 446.909,200.082 449,190.5C 453.515,180.141 458.015,169.807 462.5,159.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.934
    },
    fill: "#fefffe",
    d: "M 723.5,159.5 C 738.848,159.167 754.181,159.501 769.5,160.5C 764.167,172.167 758.833,183.833 753.5,195.5C 753.709,196.086 754.043,196.586 754.5,197C 771.843,197.167 789.176,197.667 806.5,198.5C 801.887,201.93 796.887,204.764 791.5,207C 762.833,207.667 734.167,207.667 705.5,207C 704.446,205.612 704.28,204.112 705,202.5C 711.465,188.266 717.631,173.932 723.5,159.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.947
    },
    fill: "#fe1300",
    d: "M 830.5,159.5 C 845.837,159.333 861.17,159.5 876.5,160C 874.74,163.351 873.406,166.851 872.5,170.5C 878.842,170.666 885.175,170.5 891.5,170C 894.115,166.938 895.781,163.438 896.5,159.5C 911.848,159.167 927.181,159.501 942.5,160.5C 937.186,171.296 928.519,177.796 916.5,180C 900.167,180.333 883.833,180.667 867.5,181C 863.484,189.364 859.484,197.698 855.5,206C 840.837,206.5 826.17,206.667 811.5,206.5C 811.523,204.073 812.023,201.74 813,199.5C 819.12,186.262 824.954,172.929 830.5,159.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.961
    },
    fill: "#fe1300",
    d: "M 962.5,159.5 C 977.848,159.167 993.181,159.501 1008.5,160.5C 1006.59,163.64 1005.26,166.973 1004.5,170.5C 1010.84,170.666 1017.18,170.5 1023.5,170C 1025.75,166.832 1027.75,163.499 1029.5,160C 1044.51,159.167 1059.51,159.334 1074.5,160.5C 1068.91,171.48 1059.91,177.813 1047.5,179.5C 1049.66,188.46 1051.66,197.46 1053.5,206.5C 1038.5,206.5 1023.5,206.5 1008.5,206.5C 1007.22,198.141 1005.72,189.807 1004,181.5C 1001.96,180.228 1000.12,180.561 998.5,182.5C 994.945,190.44 991.279,198.273 987.5,206C 972.837,206.5 958.17,206.667 943.5,206.5C 943.737,203.353 944.57,200.353 946,197.5C 951.787,184.929 957.287,172.262 962.5,159.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.961
    },
    fill: "#fe1300",
    d: "M 1093.5,159.5 C 1108.5,159.5 1123.5,159.5 1138.5,159.5C 1133.96,170.917 1129.13,182.25 1124,193.5C 1123.51,194.793 1123.34,196.127 1123.5,197.5C 1129.51,197.666 1135.51,197.499 1141.5,197C 1142.42,196.626 1143.25,196.126 1144,195.5C 1148.88,183.709 1154.04,172.042 1159.5,160.5C 1174.82,159.334 1190.16,159.167 1205.5,160C 1200.48,171.211 1195.31,182.378 1190,193.5C 1184.71,199.563 1178.21,203.729 1170.5,206C 1143.17,206.667 1115.83,206.667 1088.5,206C 1080.6,203.71 1077.77,198.543 1080,190.5C 1084.22,180.014 1088.72,169.68 1093.5,159.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsfuel);
export default __webpack_public_path__ + "static/media/usfuel.9e761d18f144058fc6ba0260a1203f5e.svg";
export { ForwardRef as ReactComponent };